import styled from 'styled-components';

import { FilterOptionRadio } from 'src/pages/CatalogPage/components/FilterMenu/FilterMenuOption/FilterMenuOption.style';
import { ICaliberTab } from 'src/pages/CatalogPage/components/FilterMenu/FiltersMobileMenu/FiltersMobileMenu.i';
import { Modal, ModalCloseButton } from '@riac/design-system';
import { TextButton } from '@riac/design-system';

export const FilterOptionRadioMobile = styled(FilterOptionRadio)`
  color: ${(props) => props.theme.black[80]};
  width: 100%;
  padding: 10px 0;
  margin-bottom: 0;

  ${(props) => props.theme.tablet} {
    padding: 0;
  }
`;

export const FiltersMobile = styled.div`
  max-width: 400px;
  margin: auto;
`;

export const FiltersMobileModal = styled(Modal)`
  ${ ModalCloseButton } {
    position: fixed;
  }
`;

export const FilterButtons = styled.div`
  display: flex;
  flex-flow: column no-wrap;
  justify-content: space-between;
  align-items: center;

  ${TextButton} {
    font-weight: bold;
    padding: 1em 0;
  }
`;

export const SessionFilter = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const CaliberTab = styled.div<ICaliberTab>`
  flex: 1;
  display: ${(props) => props.show ? 'block' : 'none'};
`;

export const CaliberTabBackButton = styled(TextButton)`
  background: none;
  font-size: 1.8rem;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    font-size: 1.4rem;
    margin-top: -3px;
    margin-right: 5px;
  }
`;

export const FilterFacetButton = styled(TextButton)`
  background: none;
  padding: 0;
  line-height: 0;
  margin-left: 10px;
  min-height: 44px;

  ${(props) => props.theme.tablet}
  {
    min-height: auto;
  }
`;

export const FiltersMobileMenuLoadingFloat = styled.div`
  position: absolute;
  right: 5px;
  top: -25px;
`;

export const CollectionsList = styled.ul`
  list-style: none;
`;
